import styled from 'styled-components';
import Slider from 'react-slick/lib';
import React from 'react';
import RightArrow from './svg/right-arrow.svg';

export const StyledSlider = styled(Slider)`
  max-height: 100vh;
  margin: 1rem 0;
  .slick-list {
    transition: height 0.5s ease-in-out;
  }
`;

export const SlideWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  padding: 0 8rem;
  background: transparent;
  height: auto;

  h1,
  h2,
  h3 {
    text-align: center;
  }

  h3 {
    font-size: 1.6rem;
  }

  iframe {
    padding: 0 1rem;
  }
`;

export const StyledUL = styled.ul`
  li {
    font-size: 1.6rem;
    line-height: normal;
    padding-bottom: 1.6rem;
  }
`;

const SlideNavArrow = styled.img`
  display: block;
  height: 50px;
  width: 50px;
  margin: 0 1rem;
  z-index: 2;
  &:hover {
    cursor: pointer;
  }
`;

const SlideNavArrowFlipped = styled(SlideNavArrow)`
  transform: scale(-1);
`;

const ArrowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
`;

export const NextSlide = props => {
  const { onClick } = props;
  return (
    <ArrowContainer style={{ right: 0 }}>
      <SlideNavArrow src={RightArrow} alt="right-arrow" onClick={onClick} />
    </ArrowContainer>
  );
};

export const PrevSlide = props => {
  const { onClick } = props;
  return (
    <ArrowContainer style={{ left: 0 }}>
      <SlideNavArrowFlipped
        src={RightArrow}
        alt="left-arrow"
        onClick={onClick}
      />
    </ArrowContainer>
  );
};
